module.exports = __webpack_public_path__ + "static/the-spider-network-8c61d497eb756bc3bf7e36a5f689208d.jpg";